import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

export default class Dot extends Component {
  static propTypes = {
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: '#979797',
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        width={width}
        height={height}
        viewBox="0 0 4 4"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-20 -868)" fill={strokeColor}>
            <circle cx="22" cy="870" r="2" />
          </g>
        </g>
      </SVGElement>
    );
  }
}
